import {
  Directive,
  AfterViewInit,
  OnDestroy,
  Renderer2
} from '@angular/core';
import { IgxGridComponent } from 'igniteui-angular';
import { debounceTime, from, map, Subject, switchMap, takeUntil } from 'rxjs';
import { CardAutoSizeMessage, Messenger } from '@app/shared';

@Directive({
  selector: '[autoResize]',
  standalone: false,
})
export class AutoResizeDirective implements AfterViewInit, OnDestroy {
  private resizeObserver!: ResizeObserver;

  private readonly destroying$ = new Subject<void>();
  private readonly resizingQueue$ = new Subject<void>();

  constructor(private grid: IgxGridComponent, private renderer: Renderer2, private messenger: Messenger) {}

  ngAfterViewInit(): void {

    this.resizingQueue$.pipe(      
      takeUntil(this.destroying$),     
      //debounceTime(5),           
      map(_ =>  this.updateSize()),      
    ).subscribe();     

    this.resizingQueue$.next();


  

    // Observe the parent of the grid (e.g., container div)
    let parent = this.grid.nativeElement.parentElement.parentElement;

    if (parent) {
      this.resizeObserver = new ResizeObserver(() => this.resizingQueue$.next());

      while(parent)
      {
        this.resizeObserver.observe(parent);
        parent = parent.parentElement;
      }      
    }
  }

  private updateSize(): void {
    //grid is igxgrid
    //parentElement 1 is the div the igx is in
    //parentElement 2 is the grid control
    //parentElement 3 is the container the grid control is placed in the macd dashboard component
    
    let parent = this.grid.nativeElement.parentElement.parentElement.parentElement;
    if (parent) {
      let width = parent.offsetWidth;
      let height = parent.offsetHeight;

      this.grid.width = `${width}px`;
      this.grid.height = `${height - 88}px`;

      this.grid.reflow();

      this.messenger.send(new CardAutoSizeMessage(height - 175));

      console.log('resized', width, height);
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    this.destroying$.next();
    this.destroying$.complete();
  }
}
